/** 抽奖活动编号常量 */

/** D3 — 特斯拉抽奖（任务模式），通过 URL ?lotteryid=D3 配置 */
export const LOTTERY_CODE_D3 = "D3";
